import { AsyncStateStatus, IPaginator } from '../root.types'

/**
 * Redux Actions Company
 * @typedef PersonTypes
 * @namespace PersonTypes
 * @category React
 * @subcategory Redux / Types
 */

/**
 * Typing constant of action identifiers.
 * </br>
 * The action identifiers are:
 * <pre>
 *     <ul>
 *         <li>@person/personRequest</li>
 *         <li>@person/describeRequest</li>
 *      </ul>
 * </pre>
 * @memberof PersonTypes
 * @function
 * @category React
 * @subcategory Redux / Types
 */
export enum PersonTypes {
    PERSON_REQUEST = '@person/personRequest',
    PERSON_CANCEL = '@person/personCancel',
    DESCRIBE_REQUEST = '@person/describeRequest',
    ADDRESS_REQUEST = '@person/addressRequest'
}

/**
 * @memberof CompanyTypes
 * @interface IActionPersonRequest
 * @category React
 * @subcategory Redux / Types
 * @property {IFiltersPerson} filters Person data filters.
 * @property {IPaginator} paginator Person data paginator.
 */
export interface IActionPersonRequest {
    readonly filters?: IFiltersPerson
    readonly paginator?: IPaginator
}

/**
 * @memberof CompanyTypes
 * @interface IDescribeState
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 * @property {string} cpf
 * @property {string} name
 * @property {ITabDescribe} personDatas
 * @property {ITabDescribe} personAddress
 * @property {ITabDescribe} personContacts
 * @property {ITabDescribe} personWorks
 * @property {ITabDescribe} personAutos
 */
export interface IDescribeState {
    readonly status: AsyncStateStatus,
    readonly cpf: string
    readonly name: string
    readonly personDatas: ITabDescribe
    readonly personContacts: ITabDescribe
    readonly personAddress: ITabDescribe
    readonly personWorks: ITabDescribe
    readonly personAutos: ITabDescribe
}

export interface IFiltersPerson {
    readonly cpf?: string
    readonly name?: string
    readonly rg?: string,
    start_date?: string,
    end_date?: string,
}

export enum FIlterTypePerson {
    CPF = 'cpf',
    NAME = 'name',
    RG = 'rg',
    EMAIL = 'email',
    PHONE = 'telefone',
    NULL =  'null'
}

interface ITabDescribe {
    readonly data: any[]
    readonly status: AsyncStateStatus
}

/**
 * @memberof PersonTypes
 * @interface IPersonState
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 * @property {string} name
 * @property {Array} data
 */
export interface IPersonState {
    readonly status: AsyncStateStatus,
    readonly name: string
    readonly data: any[]
}


/**
 * @memberof PersonTypes
 * @interface PersonState
 * @category React
 * @subcategory Redux / Types
 * @property {IPersonState} request
 * @property {IDescribeState} describe
 */
export interface PersonState {
    request: IPersonState,
    describe: IDescribeState,
    address: ITabDescribe
}
